module.exports = __webpack_public_path__ + "img/primary-eye.d099447e.svg";